export const ToBoolean = (value, defaultValue = false) => {
  if (value === true) return true;
  if (value === 'true') return true;
  if (value === false) return false;
  if (value === 'false') return false;
  return defaultValue;
};
